import { isRouteErrorResponse, useRouteError } from 'react-router';

import { Footer } from '@/components/layout/footer';
import { Logo } from '@/components/layout/logo';

/** Last-resort boundary for render errors and bad runtime config. */
export function ErrorPage() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';
  return (
    <div className="public">
      <div className="public__body" style={{ gridTemplateColumns: '1fr', maxWidth: '36rem' }}>
        <div className="stack">
          <Logo />
          <h1>Whoops!</h1>
          <h2>Something went wrong.</h2>
          <p className="muted">{detail}</p>
          <p>
            <a href="/" className="btn btn--primary">
              Back to home
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
